﻿import inactiveReason from "@nkr/views/reports/administration/inactive-reason"

export interface IRecipientGeneral {
    alias: string,
    mrn: string,
    transplantDate: string,
    adpStatus: number,
    isActive: boolean,
    pairCoordinatorId: number,
    administrativeComments: string,
    comments: string,
    userName: string,
    crossReferenceHint: string,
    inactiveReason: number,
    inactiveReasonDate: string,
    compatiblePairKPDReasons: number[],
    compatiblePairOtherReason: string,
    isCompatiblePair: boolean,
    dateRegistered: string,
    firstExportableDate: string,
    patientTypeId: number,
    patientType: string,
    pairStatus: number,
    canSetVoucherActive: boolean,
    isAdpChip: boolean,
    adpFormPath: string,
    voucherConsentsReviewed: boolean | null
}

export interface IRecipientGeneralDataRequest {
    userName: string,
    comments: string,
    alias: string,
    crossReferenceHint: string
    mrn: string,
    transplantDate: string,
    isActive: boolean,
    pairCoordinatorId: number
    isCompatiblePair: boolean,
    inactiveReason: number,
    inactiveReasonDate: string,
    compatiblePairKPDReasons: number[],
    compatiblePairOtherReason: string,
    adpStatus: number,
    voucherConsentsReviewed: boolean | null
}